import pick from 'lodash/pick';
import { GVL } from '@iabtcf/core';
import { ConsentLanguages } from './consent-languages';
import config, { PurposeIds } from './config';

// Override consentLanguages because the library does not support every
// language listed under https://register.consensu.org/translation.
//
// https://github.com/InteractiveAdvertisingBureau/iabtcf-es/blob/master/modules/core/src/model/ConsentLanguages.ts#L3-L31
GVL.consentLanguages = new ConsentLanguages();

GVL.baseUrl = `${window.location.origin}/consent`;

export function createGvl(config) {
  const gvl = new GVL(require('../../vendor/consent-manager-vendors'));
  gvl.narrowVendorsTo(config.vendorIds);
  return gvl;
}

const gvl = createGvl(config);

// Lists purposes that we support. We ignore the rest.
export function listPurposes() {
  return pick(gvl.purposes, Object.values(PurposeIds));
}

export default gvl;
